module.exports = __webpack_public_path__ + "images/app_icon.jpeg?1641229c01c4bb36041d0648257174b3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app_icon.jpeg
// module id = 54
// module chunks = 0